<template>
    <div class="md nav">
        <ul>
            <li
                v-for="$item in data"
                :key="$item.sn"
                :class="[
                    $item.subs && $item.subs.length? 'is-parent': '',
                    $item.open? 'is-open': '',
                    $item.active? 'is-active': '',
                ]"
            >
                <cpLink
                    :node="$item"
                    @click="clickNav($item)"
                ></cpLink>
                <ul
                    v-if="$item.subs"
                    class="func">
                    <li
                        v-for="$$item in $item.subs"
                        :key="$$item.sn"
                        :class="[$$item.active? 'is-active': '']"
                    >
                        <cpLink
                            :node="$$item"
                            @click="clickNav($$item)"
                        ></cpLink>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</template>

<script>
    import cpLink from '@/components/cpLink'

    export default {
        components: {
            cpLink,
        },
        props: {
            data: {
                type: Array,
                require: false,
                default: function(){
                    return []
                }
            },
        },
        methods: {
            clickNav: function(opt){
                this.$emit('sendEvent', 'clickNav', opt);
            },
        },
    }
</script>

<style scoped lang="scss">

    .md.nav {
        $icon-font-padding: 20px;
        $padding-left: 20px;
        $icon-left: 13px;

        user-select: none;

        > ul {

            > li {
                position: relative;

                + li {
                    margin-top: $interval-xs;
                
                    @include media('mobile') {
                        margin-top: $interval-s;
                    }
                }

                > a {
                    padding-left: $padding-left + $icon-font-padding;
                    border-radius: $border-radius;

                    &::before,&::after {
                        @extend %font-pseudo;
                        top: 4px;
                    }

                    &::before {
                        content: '\e55c';
                        left: $icon-left;
                        position: absolute;
                        font-size: $font-size-l;
                        margin-right: 0;
                    }
                }

                > /*ul*/.func { //第 2 層
                    position: relative;

                    &::before {
                        transition: $transition;
                        content: $content;
                        position: absolute;
                        width: 1px;
                        left: $padding-left;
                        top: 0;
                        bottom: 0;
                        background-color: $forth-color;

                        @include media('mobile') {
                            background-color: $white;
                        }
                    }

                    > li {
                        margin-top: $interval-s;

                        > a {
                            padding: $interval-s $interval-m;
                            margin-left: $padding-left * 2;
                            border-radius: $border-radius;
                        }
                    }
                }
            }
        }

        ul {
            @extend %reset;

            &.func {
                transition: 600ms;
                overflow: hidden;
                max-height: 0;
            }
        }

        li {
            transition: $transition;

            &:hover {
                
            }

            &.is-active {

                > a {
                    background-color: $forth-color;
                    color: $white;

                    @include media('mobile') {
                        background-color: $white;
                        color: $forth-color;
                    }
                }
            }

            &.is-parent {

                > a {
                    padding-right: $interval-xl + $interval-m;

                    &::after {
                        content: '\e5c5';
                    }
                }

                &.is-open {

                    > a {

                        &::after {
                            content: '\e5c7';
                        }
                    }

                    > /*ul*/.func {
                        padding-bottom: $interval-s;
                        max-height: 600px;
                    }
                }
            }
        }

        a {
            @extend %ellipsis;
            display: block;
            position: relative;
            cursor: pointer;
            padding: $interval-s;
            transition: $transition;
            color: $forth-color;

            @include media('mobile') {
                font-size: $font-size-l;
                color: $white;
            }

            &:hover {
                opacity: $opacity-m;
            }

            &::after {
                position: absolute;
                top: $interval-xs;
                right: $interval-xs;
                bottom: $interval-xs;
                width: $interval-xl - $interval-xs;
                // border-radius: $border-radius;
                cursor: pointer;
                text-align: center;
            }
        }
    }
</style>
